export interface TasksResponse {
  success: boolean;
  data: Array<TaskItem>;
  total: number;
}

export interface TaskItem {
  _id: string;
  ownerId: string;
  ownerUserName: string;
  companies: Array<Company>;
  hasFailedTasks: boolean;
  progress: number;
  progressPercentage?: number;
  recordSource: number;
  startDate: string;
  specifics?: any;
  status: number;
  targets: Array<any>;
  targetsCount: number;
  taskName: string;
  type: number;
}

export interface Company {
  id: string;
  name: string;
}

export interface TasksReadRecordsRequestData {
  page: number;
  limit: number;
  filter: Array<TasksFilter>;
  sort: string;
  dir: string;
}

export interface DeleteTaskItem {
  _id: string;
  type: number;
}

export interface RetryTaskItem {
  _id: string;
  type: number;
  ownerId: string;
}

export interface TasksDeleteTasksRequestData {
  records: Array<DeleteTaskItem>;
}

export interface TasksDeleteTasksResponseData {
  success: boolean;
}

export interface TasksFilter {
  property: string;
  value: string | number;
}

export interface AvailableCompaniesResponse {
  data: Array<AvailableCompany>;
}

export interface TasksRetryTasksRequestData {
  records: Array<RetryTaskItem>;
}

export interface TasksRetryTasksResponseData {
  success: boolean;
}

export interface AvailableCompany {
  name: string;
  _id: string;
}

export enum TasksMethod {
  READ_RECORDS = 'readRecords',
  CREATE_TASKS = 'createTasks',
  REMOVE_RECORDS = 'removeRecords',
  RETRY_TASKS = 'retryTasks',
}
